import { MultiSelect } from '../common/MultiSelect'
import { Button } from '../common/Button'
import { IconButton } from '../common/IconButton'

const WorkforceFilters = ({
  showFilters,
  onFiltersClose,
  filterOptions,
  filterOptionsLoading,
  filters,
  onFiltersChange,
  getFilteredDepartments,
  getFilteredRoles,
  uniqueLocations,
  uniqueStatuses,
  projects,
  allocationLoading,
  onClearFilters
}) => {
  if (!showFilters) return null

  const filterConfigs = [
    {
      label: "Parent Department",
      options: filterOptionsLoading ? [] : filterOptions.parentDepartments.map(dept => ({ value: dept, label: dept })),
      selectedValues: filters.parentDepartment,
      key: 'parentDepartment',
      placeholder: filterOptionsLoading ? "Loading..." : "All Parent Departments"
    },
    {
      label: "Department",
      options: filterOptionsLoading ? [] : getFilteredDepartments.map(dept => ({ value: dept, label: dept })),
      selectedValues: filters.department,
      key: 'department',
      placeholder: filterOptionsLoading ? "Loading..." : "All Departments"
    },
    {
      label: "Role",
      options: filterOptionsLoading ? [] : getFilteredRoles.map(role => ({ value: role, label: role })),
      selectedValues: filters.role,
      key: 'role',
      placeholder: filterOptionsLoading ? "Loading..." : "All Roles"
    },
    {
      label: "Location",
      options: filterOptionsLoading ? [] : uniqueLocations.map(location => ({ value: location, label: location })),
      selectedValues: filters.location,
      key: 'location',
      placeholder: filterOptionsLoading ? "Loading..." : "All Locations"
    },
    {
      label: "Status",
      options: uniqueStatuses.map(status => ({ value: status, label: status })),
      selectedValues: filters.status,
      key: 'status',
      placeholder: filterOptionsLoading ? "Loading..." : "All Status"
    },
    {
      label: "Experience",
      options: [
        { value: '0-1', label: '0-1 years' },
        { value: '1-3', label: '1-3 years' },
        { value: '3-5', label: '3-5 years' },
        { value: '5-8', label: '5-8 years' },
        { value: '8-10', label: '8-10 years' },
        { value: '10+', label: '10+ years' }
      ],
      selectedValues: filters.experience,
      key: 'experience',
      placeholder: "All Experience"
    },
    {
      label: "All Projects",
      options: Array.isArray(projects) ? projects.map(project => ({ 
        value: project.name || project || 'Unnamed Project', 
        label: project.name || project || 'Unnamed Project' 
      })) : [],
      selectedValues: filters.project,
      key: 'project',
      placeholder: allocationLoading ? "Loading..." : "All Projects"
    }
  ]

  return (
    <div className="mb-6 p-4 bg-slate-50 border border-slate-200 rounded-lg animate-fade-in shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-slate-900">Filter Options</h3>
        <IconButton onClick={onFiltersClose} size="sm">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </IconButton>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {filterConfigs.map(config => (
          <MultiSelect
            key={config.key}
            label={config.label}
            options={config.options}
            selectedValues={config.selectedValues}
            onSelectionChange={(values) => onFiltersChange(config.key, values)}
            placeholder={config.placeholder}
            searchPlaceholder={`Filter ${config.label.toLowerCase()}...`}
          />
        ))}
      </div>

      <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-slate-200">
        <Button variant="ghost" onClick={onClearFilters} size="sm">
          Clear all filters
        </Button>
        <Button onClick={onFiltersClose} size="sm">
          Apply Filters
        </Button>
      </div>
    </div>
  )
}

export default WorkforceFilters
